import React from "react";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";

import { Button } from "react-admin";

import { AddressInput } from "./AddressInput";
import { CancelIcon, OKIcon } from "./iconography";
import { isFullAddress } from "../../utils/utils";

export const AddressDialog = ({
  open,
  title = "Edit Address",
  formData,
  onClose,
  onSave,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <AddressInput
          source="savedAddress"
          variant="outlined"
          fullWidth
          showBusinessName={true}
          showPhone={true}
          required
          parse={(v) => (v !== "" ? v : undefined)}
          allValues={formData}
        />
      </DialogContent>
      <DialogActions>
        <Button label="Cancel" color="default" onClick={onClose}>
          <CancelIcon />
        </Button>
        <Button
          label="Confirm"
          color="primary"
          disabled={
            !formData.savedAddress || !isFullAddress(formData.savedAddress)
          }
          onClick={onSave}
        >
          <OKIcon />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
